<template>
    <ValidationProvider v-slot="{ classes, errors }"
            :class="{ required: isRequired }"
            :rules="rules">
        <label class="inputlabel" :class="{ required : required }" v-if="label">{{ label }}</label>
        <div class="radio">
            <div v-for="option in options"
                :key="option.value" class="custom-radio-option">
                <input type="radio"
                    :name="option.value"
                    :value="option.value"
                    class="radio-btn"
                    :class="classes"
                    v-model="valueModel"
                    :required="required"
                    :id="'radio-' + _uid + '-' + option.value"
                    :tabindex="tabindex"
                    @keydown.enter.stop.prevent
                />
                <label :for="'radio-' + _uid + '-' + option.value" v-html="$t(option.label)"/>
            </div>
        </div>
        <div  v-if="errors[0]" class="errors salutation-error"><SvgIcon type="attention_bar"/>{{ errors[0] }}</div>
        <slot/>
    </ValidationProvider>
</template>

<script>
import BaseField from './BaseField'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'Radio',
    components: {
        SvgIcon
    },
    extends: BaseField,
    props: {
        label: {
            type: String
        },
        options: {
            type: Array
        },
        type: {
            type: String
        },
        required: {
            type: Boolean
        },
        tabindex: {
            type: String
        }
    },
    data() {
        return {
            valueModel: null
        }
    },
    watch: {
        valueModel() {
            this.$emit('inputChanged', this.valueModel)
            this.$emit('input', this.valueModel)
        },
        value() {
            this.valueModel = this.value
        }
    },
    updated() {
        this.valueModel = this.value
    }
}
</script>
